import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  Input,
  TextField,
} from "@mui/material";
import { useLocation, Redirect } from "react-router-dom";
import { callAPI } from "../../../App/Helpers/callApi";
import Signifier from "../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { getBase64 } from "../../../App/Helpers/base64";
import { editEventSponsor } from "../EventSponsorsService";

function EventSponsorDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    card: {
      marginTop: "20px",
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    image: {
      maxWidth: "100px",
      height: "auto",
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  let location = useLocation();
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [clientId, setClientId] = useState("");
  const [processing, setProcessing] = useState(false);
  const selectCareersClient = useSelector(selectCareersClientValue);
  const [fileName, setFileName] = useState("");
  const [contentType, setContentType] = useState("");
  const [encodedImage, setEncodedImage] = useState([]);
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [inputError, setInputError] = useState(false);
  const [displayedImage, setDisplayedImage] = useState("");
  const [id, setId] = useState("");

  function editSponsor() {
    if (!checkAllEntered()) {
      setInputError(true);
      return;
    }
    let json = {
      Id: id,
      ClientId: clientId,
      Name: name,
      Link: link,
      base64: encodedImage,
      ContentType: contentType,
    };

    callAPI(
      editEventSponsor(json),
      "Sponsor Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    );
  }

  const uploadFile = (e) => {
    var fileType = e.target.files[0].type;

    if (fileType !== "image/png" && fileType !== "image/jpeg") {
      setInputError(true);
      return;
    }
    var image = e.target.files[0];
    getBase64(image, (result) => {
      setEncodedImage(result.split("base64,")[1]);
      setFileName(e.target.files[0].name);
      setContentType(e.target.files[0].type);
    });
  };

  const checkAllEntered = () => {
    if (link === "" || name === "") {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (location.state !== null && location.state !== undefined) {
      setName(location.state.name);
      setLink(location.state.link);
      setDisplayedImage(location.state.imagePath);
      setClientId(location.state.clientId);
      setId(location.state.id);
      setEncodedImage(location.state.imagePath.split("base64,")[1]);
    }
  }, []);

  if (location.state === null || location.state === undefined) {
    return <Redirect to="/eventsponsors" />;
  }

  if (selectCareersClient.id !== clientId && clientId !== "") {
    return <Redirect to="/eventsponsors" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <h1 className="page-title">
          {selectCareersClient.shortName} Event Sponsor Detailed
        </h1>
        <Breadcrumb />
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid xs={12} sm={6} item>
                    <TextField
                      placeholder="Name"
                      label="Name"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && name === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {inputError && name === "" && (
                      <FormHelperText className={classes.error}>
                        Name Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Link"
                      label="Link"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && link === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={link}
                      onChange={(e) => setLink(e.target.value)}
                    />
                    {inputError && link === "" && (
                      <FormHelperText className={classes.error}>
                        Link Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <label htmlFor="contained-button-file">
                      <Input
                        accept="image/*"
                        id="contained-button-file"
                        multiple
                        type="file"
                        style={{ display: "none" }}
                        onChange={(e) => uploadFile(e)}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        component="span"
                        style={{ marginTop: "10px" }}
                      >
                        Upload
                      </Button>
                    </label>
                    {inputError && (
                      <FormHelperText className={classes.error}>
                        Image Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      placeholder="File Name"
                      label="File Name"
                      variant="standard"
                      fullWidth
                      required
                      disabled
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={fileName}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <img className={classes.image} src={displayedImage} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => editSponsor()}
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default EventSponsorDetailed;
